/**
 * Created by work on 17/3/21.
 */
// export const TI_JIAN_LIST = 'TI_JIAN_LIST';
// export const REFRESH_LIST = 'REFRESH_LIST';
//
// export const tiJianList = (tiJianListData) => ({
//   type: TI_JIAN_LIST,
//   tiJianListData
// });
// export const refreshList = (refreshListData) => ({
//   type: REFRESH_LIST,
//   refreshListData
// });
export const REFRESH_LIFE_SUBTAB = 'REFRESH_LIFE_SUBTAB';
export const REFRESH_LIFE_TAB = 'REFRESH_LIFE_TAB';
export const REPORT_TOKEN = 'REPORT_TOKEN';

export const refreshLifeSubtab = (newSubTab) => ({
  type: REFRESH_LIFE_SUBTAB,
  newSubTab
});
export const refreshLifeTab = (newTab) => ({
  type: REFRESH_LIFE_TAB,
  newTab
});
export const refreshReportToken = (newReportToken) => ({
  type: REPORT_TOKEN,
  newReportToken
});


// WEBPACK FOOTER //
// ./src/actions/life.js